export default {
  COLORS: {
      GRAY: '#f6f9fc',
      //PRIMARY: '#ff0050',
      //PRIMARY: '#9f0000', // Dark RED
      PRIMARY: '#083242', //RED
      DEFAULT: '#DCDCDC',
      SECONDARY: '#86732e',
      LABEL: '#FE2472',
      INFO: '#00BCD4',
      ERROR: '#FE2472',
      DANGER: '#F44336',
      SUCCESS: '#4CAF50',
      WARNING: '#FF9800',
      MUTED: '#9FA5AA',
      INPUT: '#DCDCDC',
      ACTIVE: '#0066aa',
      BUTTON_COLOR: '#0066aa',
      PLACEHOLDER: '#9FA5AA',
      SWITCH_ON: '#0066aa',
      SWITCH_OFF: '#D4D9DD',
      GRADIENT_START: '#17C8FF',
      GRADIENT_END: '#0066aa',
      GRADIENT_END_DARK: '#AC2688',
      PRICE_COLOR: '#EAD5FB',
      BORDER_COLOR: '#E7E7E7',
      BLOCK: '#E7E7E7',
      ICON: '#4A4A4A',
      LIGHT_TRANSPARENT: 'rgba(255,255,255,.5)',
      DARK_TRANSPARENT: 'rgba(0,0,0,.5)',
      /*Gender Color */
      WOMAN: 'rgba(116,0,247,.6)',
      MAN: 'rgba(0,103,240,.6)',

      


  
      /**
       * BLUE-RGB COLORs 
      */
      // PRIMARY: '#0E71C7',
      // SECONDARY: '#C7A922',
      // PRIMARYRGB1: 'rgba(14,113,199,.1)',
      // PRIMARYRGB2: 'rgba(14,113,199,.3)',
      // PRIMARYRGB3: 'rgba(14,113,199,.5)',
      // PRIMARYRGB4: 'rgba(14,113,199,.7)',
      // PRIMARYRGB5: 'rgba(14,113,199,.9)',
    },
    SIZES: {
      BLOCK_SHADOW_RADIUS: 2,
    }
  };